import React from 'react';
import { CircularProgress } from '@mui/material';
import { useLocation } from 'react-router-dom';

const LoadingIndicator = ({ loading, children, progress }) => {
    const location = useLocation()

    if (loading) {
        return (
            location.pathname == '/act/create' ? <>
                <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center',gap:'10px', height: '100vh', position: 'absolute', top: '0px', left: '0px', zIndex: '9', background: "#FFF" }}>
                <p>Загрузка... {progress}%</p>
                <progress value={progress} max={100} ></progress>
                </div>
            </> : <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', position: 'absolute', top: '0px', left: '0px', zIndex: '9', background: "#FFF" }}>
                <CircularProgress />
            </div>)
    }

    return <>{children}</>;
};

export default LoadingIndicator;